export enum ScopeCapabilityTypeLookupValue {
  Local = 'Local',
  LongDistance = 'Long Distance',
  International = 'International'
}
